module.exports = __webpack_public_path__ + "static/media/ArbaeinCondition1405.37b9c5b7.jpg";